/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import { BuilderUserProfileRestService } from '@gh/builder-shared-data';
import { CommonUserProfileStore } from '@gh/common-shared';

import { Locale } from '@gh/core-mls';
import { of$ } from '@gh/rx';
import { switchMap$ } from '@gh/rx/operators';
import { Observable } from 'rxjs';
import { BuilderUserData } from './builder-user-context';
import { GoogleAuthService } from '@gh/core-external';

@Injectable()
export class BuilderUserProfileStore extends CommonUserProfileStore<BuilderUserData> {

  constructor(private userProfileRest: BuilderUserProfileRestService,
              private gAuthService: GoogleAuthService) {
    super();
  }

  load(params: Hash<any>): void {
    const { path, query } = params;
    const init$ = /^paypal\//.test(path) ? this.userProfileRest.completePayPalWorkflow(`${path}${query}`) : of$(
      true);

    init$.pipe(
      switchMap$(() => this.userProfileRest.get()))
      .subscribe(
        (user) => {
          window.sessionStorage.setItem('view', user.appView);
          return this.setLoggedInUser(user);
        },
        (error) => this.setLoginError(error),
      );
  }

  logout(): void {
    this.userProfileRest.logout()
      .subscribe(() => {
        this.gAuthService.signOut();
        this.setLoggedOut();
        this.shotDownIntercom();
      });
  }

  updateLocale(locale: Locale): Observable<any> {
    return this.userProfileRest.changeLanguage(locale.toStandardString());
  }

  shotDownIntercom(): void {
    window.localStorage.removeItem('intercom_boot');
    const intercom = window['Intercom'];
    intercom('shutdown');
  }
}
